import { configureStore } from "@reduxjs/toolkit";
import coursesReducer from "./courses";

export const store = configureStore({
  devTools: true,
  reducer: {
    course: coursesReducer,
  },
});
